import Logo from "../logo.svg";

export default Logo;